import { render, staticRenderFns } from "./RenewalStatus.vue?vue&type=template&id=090a7d9c&"
import script from "./RenewalStatus.vue?vue&type=script&lang=js&"
export * from "./RenewalStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports